var chunkToChildrenMap = {
	"16368": [
		24598,
		59348,
		15467,
		63831,
		80618,
		65984,
		24371,
		47575,
		52446,
		87,
		22059,
		20794,
		45324,
		40349,
		82591,
		19867,
		45829,
		41795,
		49653,
		80729,
		74837,
		62087,
		82631,
		45062,
		95682,
		91460,
		12044,
		95067,
		81796,
		578,
		51672
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));